
module.exports = function getResource(label) {
    const resources = {
        outOfStock: 'If out of stock:',
        notSubstitute: 'Do not substitute',
        substituteWith: 'Substitute with...'

    };

    return resources[label];
};
